module.exports = __webpack_public_path__ + "img/schnittkante_alugrau_ral7037.cee73451.jpg";